import React, {memo} from 'react'

import {ActionOpenLinkToRoute} from 'src/api/types'

import {classes as actionClasses} from '../support-button/SupportButton.classes'
import {UniversalDialog} from './UniversalDialog'
import {UniversalLink} from './UniversalLink'

type Props = {
  action: ActionOpenLinkToRoute
}

export const UniversalLinkAction = memo(function UniversalLinkAction({action}: Props): React.ReactElement {
  return (
    <div className={actionClasses.actionWrapper}>
      {action.dialog ? <UniversalDialog action={action} dialog={action.dialog} /> : <UniversalLink action={action} />}
    </div>
  )
})
